import { setSelectedDealer } from "components";
import { DealersAndLocationsDropdownKeys } from "components/DealersAndLocationsDropdown/queryKeys";
import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { ApiInstance } from "utils/Api";

type MonthlySmsLimitPayload = {
  monthly_sms: number;
  dealer_id: number;
};

export const useSetMonthlySmsLimitMutation = () =>
  useTypedMutation({
    mutationFn: async (payload: MonthlySmsLimitPayload) => (await ApiInstance.post("/sub_accounts/set_monthly_sms_limit", payload, ENV.twilioBaseURL)).data,
    onSuccess: payload => {
      const dealerUpdate = { twilio_monthly_sms_limit: payload.monthly_sms };

      const dealersList = typedQueryClient.getQueryData(DealersAndLocationsDropdownKeys.dealers);
      const dealerIdx = dealersList?.dealers.findIndex(dealer => dealer.id === payload.dealer_id) ?? -1;

      if (dealersList && dealerIdx !== -1)
        typedQueryClient.setQueryData(DealersAndLocationsDropdownKeys.dealers, {
          ...dealersList,
          dealers: dealersList.dealers.with(dealerIdx, { ...dealersList.dealers[dealerIdx], ...dealerUpdate })
        });

      const selectedDealer = typedQueryClient.getQueryData(DealersAndLocationsDropdownKeys.selectedDealer);
      if (!selectedDealer) return;

      setSelectedDealer({ ...selectedDealer, ...dealerUpdate });
    }
  });
